import { useSite, scrollToId, P2P_URL } from "@/lib/site";
import { LogoMark } from "./LogoMark";

export const Footer = () => {
  const { t } = useSite();
  return (
    <footer className="relative bg-[var(--bg2)] pb-10" data-testid="site-footer">
      <div className="grad-line" />
      <div className="mx-auto max-w-7xl px-5 pt-14 sm:px-8">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="flex items-center gap-3">
            <LogoMark className="h-12 w-12" />
            <span className="brand-text font-display text-xl font-black uppercase tracking-tight">Resilience Brothers</span>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-[var(--faint)]">{t.footer.links}</p>
            <div className="mt-4 flex flex-wrap gap-x-6 gap-y-3 text-sm">
              {t.nav.map((n) => (
                <button key={n.id} onClick={() => scrollToId(n.id)} data-testid={`footer-link-${n.id}`} className="text-[var(--muted)] transition-colors hover:text-[var(--text)]">{n.label}</button>
              ))}
              <a href={P2P_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-link-p2p" className="text-[var(--violet-h)] hover:underline">{t.projects.items[0].name}</a>
            </div>
          </div>
        </div>
        <p className="mt-14 font-mono text-xs text-[var(--faint)]" data-testid="footer-copyright">© {new Date().getFullYear()} Resilience Brothers. {t.footer.rights}</p>
      </div>
    </footer>
  );
};
